import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ReadyToLevelUp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ready-to-level-up" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 flex items-center justify-center">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,_var(--color-secondary)_0%,_var(--color-background)_70%)] opacity-80" />

      <div className={cn("relative container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-10 max-w-4xl leading-tight">
          Ready to Level Up Your <span className="text-primary">Online Presence?</span>
        </h2>

        <Link to="/ContactPage">
          <Button size="lg" className="h-16 px-10 text-lg md:text-xl rounded-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_30px_-5px_var(--color-primary)] hover:shadow-[0_0_50px_-5px_var(--color-primary)] transition-all duration-300 group">
            Book Your Build
            <ArrowRight className="ml-2 size-6 group-hover:translate-x-1 transition-transform" />
          </Button>
        </Link>

        <p className="mt-8 text-muted-foreground text-sm uppercase tracking-widest font-medium">
          Central Coast Owned & Operated
        </p>
      </div>
    </section>;
}